// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2ITag","content":"styles_content__2uEW0","selectAll":"styles_selectAll__2KyVF"};